/**
 * Temporarily hides the three mobile floating launchers while the page is moving.
 * The launchers fade back after scrolling stops. Open panels are not targeted.
 */
(() => {
  const mobile = window.matchMedia('(max-width: 899px)');
  const root = document.documentElement;
  const className = 'comfy-widgets-scrolling';
  let scrollEndTimer;

  const showWidgets = () => {
    window.clearTimeout(scrollEndTimer);
    root.classList.remove(className);
  };

  const onScroll = () => {
    if (!mobile.matches) {
      showWidgets();
      return;
    }

    root.classList.add(className);
    window.clearTimeout(scrollEndTimer);
    scrollEndTimer = window.setTimeout(showWidgets, 220);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('pageshow', showWidgets);

  const onBreakpointChange = () => {
    if (!mobile.matches) showWidgets();
  };

  if (mobile.addEventListener) {
    mobile.addEventListener('change', onBreakpointChange);
  } else {
    mobile.addListener(onBreakpointChange);
  }
})();


/** Keep the collapsed mobile offer above the visible product purchase bar. */
(() => {
  const mobile = window.matchMedia('(max-width: 899px)');
  const root = document.documentElement;
  const property = '--comfy-collapsed-offer-bottom';
  const collapsedSelector = 'iframe#attentive_creative[style*="height: 60px"]';
  const gap = 12;
  let sticky;
  let offer;
  let frame = 0;
  let transitionDeadline = 0;
  const transitions = new Set();

  const setBottom = (value) => {
    const next = value === null ? '' : `${value}px`;
    if (root.style.getPropertyValue(property) === next) return;
    if (next) root.style.setProperty(property, next);
    else root.style.removeProperty(property);
  };

  const updateClearance = () => {
    let bottom = null;
    if (mobile.matches && document.body.classList.contains('template-product')
        && sticky?.isConnected && offer?.isConnected && offer.matches(collapsedSelector)) {
      const bar = sticky.getBoundingClientRect();
      const tab = offer.getBoundingClientRect();
      const barStyle = window.getComputedStyle(sticky);
      const tabStyle = window.getComputedStyle(offer);
      const viewport = window.visualViewport;
      const viewTop = viewport ? viewport.offsetTop : 0;
      const viewLeft = viewport ? viewport.offsetLeft : 0;
      const viewBottom = viewTop + (viewport ? viewport.height : window.innerHeight);
      const viewRight = viewLeft + (viewport ? viewport.width : window.innerWidth);
      const currentBottom = parseFloat(tabStyle.bottom);
      const visibleBar = barStyle.display !== 'none' && barStyle.visibility === 'visible'
        && parseFloat(barStyle.opacity) > 0 && bar.width > 0 && bar.height > 0
        && bar.bottom > viewTop && bar.top < viewBottom
        && bar.right > viewLeft && bar.left < viewRight;
      if (visibleBar && tabStyle.position === 'fixed' && tab.height > 0 && tab.width > 0
          && tab.right > bar.left && tab.left < bar.right && Number.isFinite(currentBottom)) {
        // Use the measured tab to translate viewport coordinates into CSS bottom.
        // This also includes the bar's current offset, height and safe-area padding.
        bottom = Math.max(84, Math.ceil(currentBottom + tab.bottom - bar.top + gap));
      }
    }
    setBottom(bottom);
  };

  const tick = () => {
    frame = 0;
    updateClearance();
    // Follow the existing 200ms bar transition; never poll indefinitely.
    if (transitions.size && performance.now() < transitionDeadline) schedule();
    else transitions.clear();
  };
  const schedule = () => {
    if (!frame) frame = window.requestAnimationFrame(tick);
  };
  const stateObserver = new MutationObserver(schedule);
  const sizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;

  const refreshTargets = () => {
    const nextSticky = document.querySelector('.section-main-product sticky-atc');
    const nextOffer = document.querySelector('iframe#attentive_creative');
    if (sticky === nextSticky && offer === nextOffer) return;
    sticky = nextSticky;
    offer = nextOffer;
    transitions.clear();
    stateObserver.disconnect();
    sizeObserver?.disconnect();
    stateObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    for (const element of [sticky, offer]) {
      if (!element) continue;
      stateObserver.observe(element, {
        attributes: true, attributeFilter: ['class', 'style', 'hidden', 'height']
      });
      sizeObserver?.observe(element);
    }
    schedule();
  };

  // Apps and the Theme Editor can insert or replace these nodes after page load.
  new MutationObserver(refreshTargets).observe(document.body, { childList: true, subtree: true });
  refreshTargets();
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', schedule);
  window.addEventListener('pageshow', () => { refreshTargets(); schedule(); });
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('scroll', schedule, { passive: true });
  if (mobile.addEventListener) mobile.addEventListener('change', schedule);
  else mobile.addListener(schedule);

  document.addEventListener('transitionrun', (event) => {
    if (event.target !== sticky) return;
    transitions.add(event.propertyName);
    transitionDeadline = performance.now() + 1000;
    schedule();
  });
  const endTransition = (event) => {
    if (event.target !== sticky) return;
    transitions.delete(event.propertyName);
    schedule();
  };
  document.addEventListener('transitionend', endTransition);
  document.addEventListener('transitioncancel', endTransition);
  window.addEventListener('pagehide', () => {
    window.cancelAnimationFrame(frame);
    frame = 0;
    transitions.clear();
  });
})();
